import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './styles/index.css'
import './styles/tokens-despacho.css'
import { aplicarTenant } from './tenant/aplicarTenant.js'

// GEN-PX-001: restyle por tenant (src/tenant/tenant.config.js) sobre los tokens --dk-*.
aplicarTenant()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
